<div class="p-grid p-align-start vertical-container mt-1 container-fullsize">

  <div class="col-md-12 text-center">
    <!-- <img *ngIf="eleicao.logo !=null"  [src]="eleicao.logo" class="logo" alt="Responsive image"> -->
  </div>

  <div class="p-col-12  p-col-align-start ">

    <div class="box text-center shadow-lg px-5 py-5 mb-2 bg-white rounded basetext">
      <!-- INSTRUÇÃO  parametrizado carregando os dados da base-->

      <div class="text-left text-info ">
        <h4>INSTRUÇÃO</h4>
      </div>
      <div [innerHtml]="instrucao" class="text-justify mb-3">
      </div>
       <!-- FIM-INSTRUÇÃO -->

      <!-- TERMO parametrizado carregando os dados da base-->
      <div class="text-left text-info ">
        <h4>TERMO</h4>
      </div>
      <div [innerHtml] ="termo" class="text-justify">
      </div>
      <!-- FIM-TERMO -->

    </div>

    <div class="mt-4">
      <div class="float-left col-12 mb-3"> <label id="aceite" class="text-info ml-2">
        <p-checkbox [(ngModel)]="checked" binary="true" class="mr-2" pTooltip="Aceitar"></p-checkbox>
       Aceitar Termo de Uso</label>
      </div>
      <!--pTooltip="Aceitar termos de condições"-->
      <div *ngIf="!eleicaoParametrizacao">
        <button [disabled]="!checked" type="button" class="btn btn-info btn-block btn-lg"
          (click)="getTermoAceitoAvancar()" *ngIf="checked">
          CONFIRMA
          <i class="far fa-check-circle"></i>
        </button>
      </div>
    </div>

  </div>
</div>
